import {
    UPDATE_EMPLOYEE_PREFERENCES_REPORT,
    RESET_EMPLOYEE_PREFERENCES_REPORT,
} from './employeePreferencesReport.actions';
import { SortOrderType, EmployeeSelectionReportSortColumn } from '../../Enums';

/** @type {EmployeePreferencesReport.IEmployeePreferencesReport} */
const initialState = {
    employeePreferences: [],
    filters: {
        search: '',
        dataviewColumnsFilter: [],
        employeeOptionsInFilter: [],
        selectedEmployees: [],
    },
    pagination: {
        pageSize: 10,
        totalCount: 0,
        pageNumber: 1,
    },
    sortParameters: {
        sortOrder: SortOrderType.Ascending,
        sortColumn: EmployeeSelectionReportSortColumn.RANK,
    },
};

/**
 *
 * @param {EmployeePreferencesReport.IEmployeePreferencesReport} state
 * @param {ShiftBidding.IAction} action
 */
// eslint-disable-next-line default-param-last
export default function employeePreferencesReportReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_EMPLOYEE_PREFERENCES_REPORT:
            return {
                ...state,
                ...payload,
            };
        case RESET_EMPLOYEE_PREFERENCES_REPORT:
            return initialState;
        default:
            return state;
    }
}
